export const TEAMS_STATUS = {
    BLOCKED: 'Blocked',
    ACTIVE: 'Active',
    DELETED: 'Deleted',
    WAITING: 'Waiting',
};